import { render } from "./QuizQR.vue?vue&type=template&id=258af683"
import script from "./QuizQR.vue?vue&type=script&lang=js"
export * from "./QuizQR.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/samgk_quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__